<div class="user-wishlist-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="wishlist-text">{{ data.wishlist.name }}</span>
    <div class="img-container" mat-dialog-close>
      <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
    <div class="d-flex align-items-center">
      <img src="../../../assets/images/back-icon.svg" class="cross-icon" mat-dialog-close />
      <span class="wishlist-back ms-2" mat-dialog-close>Back to all wishlists</span>
    </div>
    <div class="d-flex" style="gap: 10px;">
      <!-- @if(showPrintBtn){ -->
      <button class="dp-primary-btn transfer-btn mr-8" (click)="printPDF()">
        Print
      </button>
      <!-- } -->
    </div>
  </div>
@if(reachUserWishlists.length>0){
    @if(!isMobile){
  <div class="table-container">
    <dp-table [dataTable]="reachUserWishlists" [displayedColumns]="displayColumnData" [componentMap]="cellComponentMap"
      [columnConfs]="columnConfs" (cellClick)="onCellClick($event)"></dp-table>
  </div>
}@else {
  <div class="table-container">
  @for(row of reachUserWishlists; track row){
    <div class="mobile-view-data-container">
      <div class="d-flex justify-content-between">
        <span class="header-text">Serial No.</span>
        <span class="data-text">{{ row.mem_key || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Family Code</span>
        <span class="data-text">{{ row.familyCode || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Dikshyarthi Name</span>
        <span class="data-text">{{ row.name || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Guardian Name</span>
        <span class="data-text">{{ row.guardianName || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Ritwik Name</span>
        <span class="data-text">{{ row.ritwikName || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Contact No.</span>
        <span class="data-text">{{ row.contactNo || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Address</span>
        <span class="data-text">{{ row.address || "-" }}</span>
      </div>
       <div class="d-flex justify-content-between">
        <span class="header-text">Pincode</span>
        <span class="data-text">{{ row.pincode || "-" }}</span>
      </div>
    </div>
  }

  </div>

}
  <div class="d-flex justify-content-end" style="gap: 10px;">
    <button class="dp-primary-btn transfer-btn" (click)="deleteEntireWishlist()">
      Delete entire wishlist
    </button>
  </div>

}@else {
  <div class="noData">
    <div class="placeholderTable"></div>
    <p>No data found!</p>
  </div>
}
</div>
<app-loader [isLoading]="isLoading"></app-loader>